export enum IncomingWebEvent {
  TRIP_LOGGED = 'tripLogged',
}
